import { render, staticRenderFns } from "./UpdatesFilter.vue?vue&type=template&id=02d80f71&scoped=true&"
import script from "./UpdatesFilter.vue?vue&type=script&lang=ts&"
export * from "./UpdatesFilter.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatesFilter.vue?vue&type=style&index=0&id=02d80f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d80f71",
  null
  
)

export default component.exports